import { render, staticRenderFns } from "./remotemark.vue?vue&type=template&id=54203b5a&scoped=true"
import script from "./remotemark.vue?vue&type=script&lang=js"
export * from "./remotemark.vue?vue&type=script&lang=js"
import style0 from "./remotemark.vue?vue&type=style&index=0&id=54203b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54203b5a",
  null
  
)

export default component.exports